export default __webpack_public_path__ + "static/media/Icon-angle-down-gray.a2ebd748.svg";